export default {
  title: 'Your username has been updated.',
  information: 'You can use your new username to log in now:',
};
